export const USER_SEARCH_VERSION = '1';

export const SEARCH_PARAMS_CHANGED = 'SEARCH_PARAMS_CHANGED';
